



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETBLOGSECTIONBYID
// GETBLOGSECTIONBYID


const GETBLOGSECTIONBYID= createAsyncThunk(
  "getBlogSectionById/getBlogSectionById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getBlogSectionByIdSlice = createSlice({
  name: "getBlogSectionByIdSlice",
  initialState: {
    getBlogSectionById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetBlogSectionById: (state) => {
        state.getBlogSectionById.loading = false
        state.getBlogSectionById.error = false
        state.getBlogSectionById.data = []
        state.getBlogSectionById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETBLOGSECTIONBYID.fulfilled, (state, action) => {
      state.getBlogSectionById = {
        ...state.getBlogSectionById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETBLOGSECTIONBYID.pending, (state, action) => {
      state.getBlogSectionById = {
        ...state.getBlogSectionById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETBLOGSECTIONBYID.rejected, (state, action) => {
      state.getBlogSectionById = {
        ...state.getBlogSectionById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getBlogSectionByIdAction = {
    GETBLOGSECTIONBYID,
};

export { getBlogSectionByIdAction };
export default getBlogSectionByIdSlice.reducer;
export const {setInitialStateOfgetBlogSectionById} = getBlogSectionByIdSlice.actions
